import { __rest } from "tslib";
import * as React from 'react';
const SeatMapContext = React.createContext(null);
export function useSeatMapCtx() {
    return React.useContext(SeatMapContext);
}
const SeatMapProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(SeatMapContext.Provider, { value: props }, children);
};
export default SeatMapProvider;
